import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

interface ExportMenuProps {
  onExport: (exportType: string) => void;
  onClose: () => void;
  anchorEl: HTMLElement | null;
}

const ExportMenu: React.FC<ExportMenuProps> = ({ onExport, onClose, anchorEl }) => {
  const menuRef = useRef<HTMLDivElement>(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    if (anchorEl) {
      const rect = anchorEl.getBoundingClientRect();
      setMenuPosition({
        top: rect.bottom + window.scrollY,
        left: rect.right - 192 + window.scrollX, 
      });
    }
  }, [anchorEl]);

  return ReactDOM.createPortal(
    <div
      ref={menuRef}
      className="fixed w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 m-2"
      style={{
        zIndex: 9999,
        top: `${menuPosition.top}px`,
        left: `${menuPosition.left}px`,
      }}
    >
      <div
        className="py-1"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        {['Image', 'CrossTab', 'PDF', 'PowerPoint'].map((option) => (
          <button
            key={option}
            onClick={() => onExport(option)}
            className="block w-full text-left px-4 py-2 text-[14px] text-gray-700 hover:bg-gray-100 hover:text-gray-900"
            type="button"
          >
            {option}
          </button>
        ))}
      </div>
    </div>,
    document.body
  );
};

export default ExportMenu;